import createCache, { EmotionCache } from "@emotion/cache"
import type { SerializedStyles } from "@emotion/utils"

type CssRuleCollector = {
  insert: (rule: string) => void
}

function createCssRuleCollector(): CssRuleCollector & { getCss: () => string } {
  let css = ""

  return {
    insert(rule: string) {
      css += rule
    },
    getCss() {
      return css
    }
  }
}

export const createPdfEmotionCache = (key = "pdf-generator"): EmotionCache => {
  const cache = createCache({ key, prepend: true })
  const emotionInsert = cache.insert

  cache.insert = (
    selector: string,
    serialized: SerializedStyles,
    _sheet: Parameters<EmotionCache["insert"]>[2],
    shouldCache: boolean
  ) => {
    const ruleCollector = createCssRuleCollector()

    emotionInsert(
      selector,
      serialized,
      ruleCollector as Parameters<EmotionCache["insert"]>[2],
      shouldCache
    )

    if (shouldCache) {
      cache.inserted[serialized.name] = ruleCollector.getCss()
    }
  }

  return cache
}
